import React, { useState, useEffect, useContext } from "react";
import { AudioContext } from "../context/AudioContext";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../config/config";
import { Link } from 'react-router-dom';

const LanguageByChannels = () => {
    const { language } = useParams();
    const { setCurrentChannel } = useContext(AudioContext);
    
    const [channels, setChannels] = useState([]); // Changed to array
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchChannelData = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${BASE_URL}/channel/language/${language}`);
                if (!response.ok) throw new Error("Failed to fetch data");

                const data = await response.json();
                setChannels(data); // Store as an array
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchChannelData();

        // Load history from sessionStorage
        const storedHistory = sessionStorage.getItem('radioHistory');
        if (storedHistory) {
            setHistory(JSON.parse(storedHistory));
        }
    }, [language]);

    const playChannel = (channel) => {
        if (!channel) return;

        setCurrentChannel(channel);

        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length > 5) updatedHistory.pop(); 

        setHistory(updatedHistory);
        sessionStorage.setItem("radioHistory", JSON.stringify(updatedHistory));
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title text-capitalize">
                            <h2>Channels in {language}</h2>
                        </div>
                    </div>

                    {channels.length === 0 ? (
                        <div className="col-12">
                            <p>No channels found.</p>
                        </div>
                    ) : (
                        channels.map((channel) => (
                            <div className="col-3 col-sm-4 col-lg-1">
                                <div className="album">
                                    <div className="album__cover" key={channel.id} onClick={() => playChannel(channel)}>
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <Link role='button' onClick={() => playChannel(channel)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="album__title">
                                        <h3 className="text-capitalize"><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h3>
                                        <span className="text-capitalize"><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="partners owl-carousel">
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LanguageByChannels;
